import { IntegrationsMarketplaceGridAvailableController } from '../controller/IntegrationsMarketplaceGridAvailableController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class IntegrationsMarketplaceGridAvailableWebComponent extends BaseWebComponentElement {
  public controller: IntegrationsMarketplaceGridAvailableController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: IntegrationsMarketplaceGridAvailableController,
    });
  }

  disconnectedCallback(): void {
    this.controller.view.unobserveGridResize();
    super.disconnectedCallback();
  }
}
